import { Link, useSearchParams } from "react-router-dom";
import { savedOfferUrl, savedOfferReturnUrl } from "../lib/savedOfferNavigation";

export default function SavedOfferDetailActions({ id, selected, ready }: { id: string; selected: string[]; ready: boolean }) {
  const [params] = useSearchParams();
  const returnUrl = savedOfferReturnUrl(selected, params);
  const included = selected.includes(id);
  const combined = included ? selected : [...selected, id];
  const full = combined.length > 3;
  const canCompare = combined.length >= 2;
  const label = included && canCompare ? "Ausgewählte Angebote vergleichen" : canCompare ? selected.length === 1 ? "Mit ausgewähltem Angebot vergleichen" : "Mit ausgewählten Angeboten vergleichen" : "Mit anderem Angebot vergleichen";
  const control = "inline-flex min-h-9 items-center justify-center rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-50";
  return <div className="flex max-w-full flex-col items-start gap-2 sm:items-end">
    <div className="flex flex-wrap items-center gap-3">
      <Link className="text-sm text-emerald-800 underline" to={returnUrl}>{selected.length ? "← Zurück zur Auswahl" : "Alle Angebote"}</Link>
      {ready && (full ? <button className={control} disabled aria-describedby="full-offer-selection">Auswahl voll</button> : <Link className={control} to={canCompare ? savedOfferUrl(combined, true, returnUrl) : savedOfferReturnUrl(combined, params)}>{label}</Link>)}
    </div>
    {full && <p id="full-offer-selection" className="max-w-sm text-sm text-slate-600">Du hast bereits drei Angebote ausgewählt. Entferne zuerst eines aus der Auswahl, um dieses hinzuzufügen.</p>}
  </div>;
}
